import { ref } from 'vue'

/**
 * Composable for clipboard copy with a timed "copied" indicator.
 *
 * Usage:
 *   const { copy, isCopied } = useCopyToClipboard()
 *   await copy(JSON.stringify(data, null, 2), entry.id)
 *   // in template: <ClipboardCheck v-if="isCopied(entry.id)" />
 */
export function useCopyToClipboard(resetAfterMs = 2000) {
  const copiedKey = ref<string | null>(null)

  async function copy(text: string, key: string | number): Promise<void> {
    const k = String(key)
    await navigator.clipboard.writeText(text)
    copiedKey.value = k
    setTimeout(() => {
      if (copiedKey.value === k) copiedKey.value = null
    }, resetAfterMs)
  }

  function isCopied(key: string | number): boolean {
    return copiedKey.value === String(key)
  }

  return { copy, isCopied }
}
